import classNames from "classnames";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { HotNews } from "../postDetailComponent/scrollRight";
import { IBaseBox, ICategory } from "../../model/base";
import styles from "./article.module.scss";
import { dataSapoProducts } from "../../model/dataGlobal";
import SapoProducts from "../postDetailComponent/SAPOProduct";
import VoteAndLike from "../postDetailComponent/voteAndLike";
import Tag from "../tag";
import { SlidePost } from "../slideComponent/slideStyle";
import YoutubeFacebook from "../YoutubeFacebook/index";
import { useWindowSize, getAdsWithCondition, findAdsByIds, addHeadingMenu, getAllCateArticle, convertSlugs } from "../../util/functionGlobal";
import moment from "moment";
import { BtnHome } from "../btnHomeAndScrollTop/btnHomeAndScrollTop";
import utils from "../../util/utils";
import ScrollMenu from "./sidebarScrollFocus";
import { BannerHeaderBreadcrumbArticle } from "../bannerHeader/bannerHeaderArticle";
import Author from "../postDetailComponent/author";
import { getAuthorInfo } from "../postDetailComponent/dataAuthor";
import { HTMLContent } from "../HtmlContent";
import ConsultBox from "../postDetailComponent/ConsultBox";
import ConsultPopup from "../postDetailComponent/ConsultPopup";

interface InfoAuthorProps {
  breadcrumb: ICategory[];
  cateMapping: any[];
  title: string;
  description?: string;
  url: string;
  modDate: string;
  view?: string;
  img: string;
  createdBy?: string;
}

const Article = ({
  article,
  articleNew,
  resultCoupon,
  articleRevelant,
  categories,
  articleInterested,
  listAds,
}: {
  article?: IBaseBox;
  categories: ICategory[];
  articleRevelant;
  articleInterested;
  articleNew;
  resultCoupon: IBaseBox[];
  listAds;
}) => {
  const [slidesPerView, setSlidesPerView] = useState<number>(4);
  const refContent = useRef<HTMLDivElement>(null);
  const refWrapperContent = useRef<HTMLDivElement>(null);
  const boxScrollRight = useRef<HTMLDivElement>(null);
  const boxScrollLeft = useRef<HTMLDivElement>(null);
  const boxScrollFocus = useRef<HTMLDivElement>(null);

  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const { width } = useWindowSize();

  const [dataTop, setDataTop] = useState<IBaseBox[]>([]);

  const [listAdsBannerTop, setListAdsBannerTop] = useState<any[]>([]);
  const [listAdsOther, setlistAdsOther] = useState<any[]>([]);
  const [listAdsBannerEbook, setListAdsBannerEbook] = useState<any[]>([]);
  const listIdAdsTop = [26, 27, 28, 29, 30, 31, 32, 34, 35, 37, 38, 143, 158, 159, 162, 197, 198, 213, 214]; // trong cái banner top là bao gồm cả banner bên góc trái
  const listIdAdsOther = [175, 205, 217, 218, 222]; //banner other là accs banner khác
  const listIdAdsEbook = [1, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 146, 147, 155, 164, 169]; //banner ebook là banner ở dưới cuối trang

  //local
  //const listIdAdsTop = [30, 31, 41, 42, 43]; // trong cái banner top là bao gồm cả banner bên góc trái
  //const listIdAdsOther = [32, 33, 34, 35, 36, 37, 38]; //banner other là accs banner khác
  //const listIdAdsEbook = []; //banner ebook là banner ở dưới cuối trang
  const treeCategory = getAllCateArticle(article.category_article_mapping, categories);

  useEffect(() => {
    if (typeof window !== undefined) {
      if (width < 480) {
        setSlidesPerView(1.25);
      } else if (width < 990) {
        setSlidesPerView(3);
      } else {
        setSlidesPerView(4);
      }
    }
  }, [width]);
  const checkHoidapCategory = treeCategory.some((item) => item.id === 86);

  useEffect(() => {
    if (checkHoidapCategory && dataTop.length === 0) {
      fetch(`/blog/api/get_top?id=${article.id}`)
        .then((response) => response?.json())
        .then((data) => {
          setDataTop(data.data);
        });
    }
  }, [checkHoidapCategory]);

  const [isExitsBanner, setIsExitsBanner] = useState<number>(1);
  useEffect(() => {
    fetch(`/blog/api/view_increase?articleId=${article?.id}`);
    if (article.ads) {
      setListAdsBannerTop(findAdsByIds(listAds, [article.ads]));
    } else {
      setListAdsBannerTop(findAdsByIds(listAds, listIdAdsTop));
    }
    setListAdsBannerEbook(findAdsByIds(listAds, listIdAdsEbook));
    setlistAdsOther(findAdsByIds(listAds, listIdAdsOther));
    setIsExitsBanner(1);
  }, [article, listAds]);

  useEffect(() => {
    if (mounted) {
      if (isExitsBanner >= 5) {
        setIsExitsBanner(0);
      } else {
        if (isExitsBanner > 0) {
          if (document.querySelector<HTMLElement>(".nav-banner")) {
            setIsExitsBanner(0);
          } else {
            setIsExitsBanner(isExitsBanner + 1);
          }
        }
        if (isExitsBanner === 0 && refWrapperContent.current) {
          const offsetTop = refWrapperContent.current.offsetTop;
          handleScroll(offsetTop);
          window.addEventListener("scroll", () => handleScroll(offsetTop));
          return () => {
            window.removeEventListener("scroll", () => handleScroll(offsetTop));
          };
        }
      }
    }
  }, [isExitsBanner, article, listAds, mounted]);

  const handleScroll = (offsetTop: number) => {
    if (refContent.current) {
      const endScroll = offsetTop + refContent.current.clientHeight;
      const scroll = window.pageYOffset;

      const navBanner = document.querySelector<HTMLElement>(".nav-banner");
      if (width > 1250) {
        if (navBanner) {
          if (scroll > offsetTop && scroll < endScroll - window.innerHeight) {
            navBanner.style.display = "block";
            navBanner.style.position = "fixed";
            navBanner.style.bottom = "0px";
            navBanner.style.left = "0px";
          } else {
            navBanner.style.display = "none";
          }
        }
        if (boxScrollLeft?.current) {
          if (scroll > offsetTop && scroll < endScroll - boxScrollLeft.current.clientHeight - 45) {
            boxScrollLeft.current.style.position = "fixed";
            boxScrollLeft.current.style.top = "20px";
          } else if (scroll > offsetTop && scroll > endScroll - offsetTop - boxScrollLeft.current.clientHeight - 45) {
            boxScrollLeft.current.style.position = "absolute";
            boxScrollLeft.current.style.top = endScroll - offsetTop - boxScrollLeft.current.clientHeight + "px";
          } else {
            boxScrollLeft.current.style.position = "absolute";
            boxScrollLeft.current.style.top = "20px";
          }
        }
        if (scroll > offsetTop && scroll < endScroll - boxScrollRight.current.clientHeight - 30) {
          boxScrollRight.current.style.position = "fixed";
          boxScrollRight.current.style.top = "30px";
        } else if (scroll > offsetTop && scroll > endScroll - offsetTop - boxScrollRight.current.clientHeight - 30) {
          boxScrollRight.current.style.position = "absolute";
          boxScrollRight.current.style.top = endScroll - offsetTop - boxScrollRight.current.clientHeight + "px";
        } else {
          boxScrollRight.current.style.position = "absolute";
          boxScrollRight.current.style.top = "30px";
        }

        if (boxScrollFocus?.current) {
          if (scroll > offsetTop && scroll < endScroll - boxScrollFocus.current.clientHeight - 30) {
            boxScrollFocus.current.style.position = "fixed";
            boxScrollFocus.current.style.top = "30px";
          } else if (scroll > offsetTop && scroll > endScroll - offsetTop - boxScrollFocus.current.clientHeight - 30) {
            boxScrollFocus.current.style.position = "absolute";
            boxScrollFocus.current.style.top = endScroll - offsetTop - boxScrollFocus.current.clientHeight + "px";
          } else {
            boxScrollFocus.current.style.position = "absolute";
            boxScrollFocus.current.style.top = "30px";
          }
        }
      } else {
        if (navBanner) {
          navBanner.style.display = "none";
        }
      }
    }
  };

  const rendProduct = (products: string) => {
    if (products) {
      const pro = JSON.parse(products);
      if (pro.length) {
        const data = dataSapoProducts.filter(function (sapoP) {
          return pro.includes(sapoP.id);
        });
        return data;
      }
    }
    return [];
  };

  useEffect(() => {
    return () => {
      document.onmouseleave = null;
      window.onscroll = null;
      document.getElementsByTagName("body")[0].classList.remove("sapo-modal-register-open");
    };
  }, [listAdsOther, article]);

  useEffect(() => {
    window.fbAsyncInit = function () {
      FB.init({
        appId: "232837080820948",
        cookie: true,
        xfbml: true,
        autoLogAppEvents: true,
        version: "v11.0",
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
    if (typeof window !== "undefined" && window.FB) {
      FB.XFBML.parse();
    }
  }, []);

  const [author, setAuthor] = useState(null);

  useEffect(() => {
    //const createdby = "ĐK";
    const authorData = getAuthorInfo(article.created_by ?? "Vân ĐK");
    if (authorData) {
      setAuthor(authorData);
    }
  }, []);

  const schemaAuthor = useMemo(() => {
    if (!author) return null;
    return {
      "@context": "https://schema.org",
      "@type": "Article",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": process.env.NEXT_PUBLIC_BASE_URL + process.env.NEXT_PUBLIC_BASE_PATH + "/" + article.alias,
      },
      headline: article.title,
      description: article.seo_description ? article.seo_description : "",
      image: process.env.NEXT_PUBLIC_BASE_IMAGE_URL + "/articles/" + article.image_src || "https://blog.dktcdn.net/files/thumbnail-blog.png",
      author: {
        "@type": "Person",
        name: author.nameAuthor + "-" + author.titleAuthor,
        description: author.descriptionAuthor,
        sameAs: [author.linkIn, "https://www.sapo.vn/blog/quy-trinh-bien-tap-noi-dung#" + convertSlugs(author.nameAuthor.toLowerCase())],
      },
      publisher: {
        "@type": "Organization",
        name: "Sapo",
        logo: {
          "@type": "ImageObject",
          url: "https://www.sapo.vn/Themes/Portal/Default/StylesV2/images/logo/Sapo-logo.svg?v=202502140818",
        },
        sameAs: ["https://www.facebook.com/sapo.vn/", "https://www.youtube.com/@Sapo-VietNam/videos", "https://www.linkedin.com/company/sapovn/"],
      },
      datePublished: article.published_at,
      dateModified: article.modified_at,
    };
  }, [author]);

  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <>{author && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaAuthor) }} />}</>
      <div id={styles["wrapper"]} className={classNames(styles["main-content"], styles["page-detail"])}>
        <div className="post-content">
          {listAdsBannerTop && listAdsBannerTop.length > 0 && !checkHoidapCategory && (
            <div className="d-none d-lg-block" dangerouslySetInnerHTML={{ __html: listAdsBannerTop[0].content }} />
          )}
          {listAdsOther && listAdsOther.length > 0 && !checkHoidapCategory && (
            <>
              {listAdsOther.map((item, index) => (
                <HTMLContent html={item.content} id={`ads-other-${index}`} key={index} />
              ))}
            </>
          )}

          <div className={styles["detail-content"]} ref={refWrapperContent}>
            <div className="container">
              <ScrollMenu refProps={boxScrollFocus} />
              <div className={classNames(styles["sidebar-scroll"], "d-none d-xl-block")} ref={boxScrollRight} id="box-question">
                {articleNew?.length > 0 && <HotNews title="Bài viết mới nhất" items={articleNew} />}
                <ConsultBox setShowForm={setShowForm} />
              </div>
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-10 col-12" ref={refContent}>
                  <div id="_content" className={styles["box-content"]}>
                    <BannerHeaderBreadcrumbArticle
                      breadcrumb={treeCategory}
                      cateMapping={article.category_article_mapping || []}
                      title={article?.title}
                      modDate={moment(article?.modified_at).format("DD-MM-YYYY")}
                      view={article?.article_view_counts?.count?.toString() || "0"}
                      img={
                        article?.image_src
                          ? process.env.NEXT_PUBLIC_BASE_IMAGE_URL + `/articles/${article?.image_src}`
                          : process.env.NEXT_PUBLIC_NO_IMAGE
                      }
                      createdBy={article.created_by}
                      article={article}
                    />
                    <div dangerouslySetInnerHTML={{ __html: addHeadingMenu(article?.content1) }} />
                    <VoteAndLike articleId={article?.id} point={article?.article_rating_point?.point} seoTitle={article.title} />
                    <Author
                      breadcrumb={treeCategory}
                      cateMapping={article.category_article_mapping || []}
                      title={article?.title}
                      description={article?.seo_description}
                      url={article.alias}
                      modDate={moment(article?.modified_at).format("DD-MM-YYYY")}
                      view={article?.article_view_counts?.count?.toString() || "0"}
                      img={
                        article?.image_src
                          ? process.env.NEXT_PUBLIC_BASE_IMAGE_URL + `/articles/${article?.image_src}`
                          : process.env.NEXT_PUBLIC_NO_IMAGE
                      }
                      createdBy={article.created_by}
                    />
                    <Tag data={article?.article_tags_mapping} />
                  </div>
                </div>
              </div>
              {articleRevelant?.length > 0 && mounted && (
                <SlidePost data={articleRevelant} title="BÀI VIẾT LIÊN QUAN" className="related-post" slidesPerView={slidesPerView} loop={true} />
              )}
              {articleInterested?.length > 0 && mounted && (
                <SlidePost data={articleInterested} title="CÓ THỂ BẠN QUAN TÂM" className="care-post" slidesPerView={slidesPerView} loop={true} />
              )}
            </div>
          </div>
        </div>
        {listAdsBannerEbook && listAdsBannerEbook.length > 0 && !checkHoidapCategory && (
          <div dangerouslySetInnerHTML={{ __html: listAdsBannerEbook[0].content }} />
        )}
        <YoutubeFacebook />
        <BtnHome />
        <ConsultPopup showForm={showForm} setShowForm={setShowForm} />
      </div>
    </>
  );
};
export default Article;
